<template>
  <div>
    <BigHeader  title="Latest News" subtitle="" icon1="" line1="" icon2=""  line2="" icon3=""  line3=""></BigHeader>

    <v-container flex grid-list-xl  class="pb-0">

      <v-layout
        text-xs-center
        wrap
      >

        <v-flex xs12 md10 xl8 offset-md1 offset-xl2  class="mb-3">

          <v-layout
            text-xs-left
            wrap
          >

            <v-flex xs12>

              <v-layout
                text-xs-left
                wrap
              >

                <v-flex id="lisa" xs12 md8>
                  <div class="title ml-3 mb-3">LISA in the news</div>
                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     " class="elevation-0">
                    <v-card-text>
                      <div class="font-weight-light text-capitalize ">Jul 26, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Dead Stars Found Whipping Around Each Other in Minutes</div>
                      <div class="body-1 lineclamp">Two dead stars have been spotted whipping around each other every seven minutes. The rare celestial find was made using Caltech's Zwicky Transient Facility (ZTF), a state-of-the-art sky survey at Palomar Observatory that rapidly scans the night skies looking for anything that moves, blinks, or otherwise varies in brightness.</div>
                      <div class="font-weight-light text-capitalize pt-3">Jul 08, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Discovering exoplanets with gravitational waves</div>
                      <div class="body-1 lineclamp">In a recent paper in Nature Astronomy, researchers from the Max Planck Institute for Gravitational Physics (Albert Einstein Institute/AEI) in Potsdam and from the French Alternative Energies and Atomic Energy Commission (CEA) in Saclay, Paris suggest how the planned space-based gravitational-wave observatory LISA can detect exoplanets orbiting white dwarf binaries everywhere in our Milky Way and in the nearby Magellanic Clouds. This new method will overcome certain limitations of current electromagnetic detection techniques and might allow LISA to detect planets down to 50 Earth masses.</div>
                      <div class="font-weight-light text-capitalize pt-3">May 23, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">ESA: A unique experiment to explore black holes</div>
                      <div class="body-1 lineclamp">What happens when two supermassive black holes collide? Combining the observing power of two future ESA missions, Athena and LISA, would allow us to study these cosmic clashes and their mysterious aftermath for the first time.</div>
                      <div class="font-weight-light text-capitalize ">Jul 26, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Dead Stars Found Whipping Around Each Other in Minutes</div>
                      <div class="body-1 lineclamp">Two dead stars have been spotted whipping around each other every seven minutes. The rare celestial find was made using Caltech's Zwicky Transient Facility (ZTF), a state-of-the-art sky survey at Palomar Observatory that rapidly scans the night skies looking for anything that moves, blinks, or otherwise varies in brightness.</div>
                      <div class="font-weight-light text-capitalize pt-3">Jul 08, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">Discovering exoplanets with gravitational waves</div>
                      <div class="body-1 lineclamp">In a recent paper in Nature Astronomy, researchers from the Max Planck Institute for Gravitational Physics (Albert Einstein Institute/AEI) in Potsdam and from the French Alternative Energies and Atomic Energy Commission (CEA) in Saclay, Paris suggest how the planned space-based gravitational-wave observatory LISA can detect exoplanets orbiting white dwarf binaries everywhere in our Milky Way and in the nearby Magellanic Clouds. This new method will overcome certain limitations of current electromagnetic detection techniques and might allow LISA to detect planets down to 50 Earth masses.</div>
                      <div class="font-weight-light text-capitalize pt-3">May 23, 2019</div>
                      <div class="font-weight-bold subheading" style="color: #ED1848;">ESA: A unique experiment to explore black holes</div>
                      <div class="body-1 lineclamp">What happens when two supermassive black holes collide? Combining the observing power of two future ESA missions, Athena and LISA, would allow us to study these cosmic clashes and their mysterious aftermath for the first time.</div>

                    </v-card-text>
                  </v-card>

                </v-flex>
                <v-flex xs12 md4>

                  <div class="title ml-3 mb-3">Latest publications</div>

                  <v-card style="border-radius: 3px; border: 1px solid lightgray;     height: calc(100% - 32px);" class="elevation-0">

                    <v-timeline
                      align-top
                      dense
                    >
                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Cool paper</strong>
                            <div class="caption">Nature</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Even cooler paper</strong>
                            <div class="caption">PhysRevLett</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Cool paper</strong>
                            <div class="caption">Nature</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Even cooler paper</strong>
                            <div class="caption">PhysRevLett</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Cool paper</strong>
                            <div class="caption">Nature</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Even cooler paper</strong>
                            <div class="caption">PhysRevLett</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Cool paper</strong>
                            <div class="caption">Nature</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                      <v-timeline-item
                        color="#ED1848"
                        small
                      >
                        <v-layout pt-3>
                          <v-flex>
                            <strong>Even cooler paper</strong>
                            <div class="caption">PhysRevLett</div>
                          </v-flex>
                        </v-layout>
                      </v-timeline-item>

                    </v-timeline>

                  </v-card>

                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>

    </v-container>

<div style="height:600px;"></div>
  </div>
</template>

<script>

  import BigHeader from '../components/BigHeader'

  export default {
    components: {
      BigHeader
    },
    data () {
      return {


      }
    }
  }
</script>
